import { render } from "./PlayPage.vue?vue&type=template&id=5bea5f52&ts=true"
import script from "./PlayPage.vue?vue&type=script&lang=ts"
export * from "./PlayPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/Admin/Plays/PlayPage.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5bea5f52"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5bea5f52', __exports__)) {
    api.reload('5bea5f52', __exports__)
  }
  
  module.hot.accept("./PlayPage.vue?vue&type=template&id=5bea5f52&ts=true", () => {
    api.rerender('5bea5f52', render)
  })

}


export default __exports__